// The ward worklist (docs/plans/phase2-ward-rounds-nursing.md §4.2).

/** How recent an order must be to show as new. TODO(clinical-verify): plan W3. */
export const NEW_ORDER_WINDOW_HOURS = 24;

const HOUR_MS = 3_600_000;

export function isNewOrder(orderedAt: Date, now: Date): boolean {
  return now.getTime() - orderedAt.getTime() <= NEW_ORDER_WINDOW_HOURS * HOUR_MS;
}

const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });

/** Bed labels as a person reads them: "B2" before "B10". */
export function compareBedLabels(a: string, b: string): number {
  return collator.compare(a, b);
}

/** Patients in beds by bed label, then those waiting for a bed by admission time. */
export function worklistOrder<T extends { bedLabel: string | null; admittedAt: Date }>(
  rows: readonly T[],
): T[] {
  return [...rows].sort((a, b) => {
    if (a.bedLabel !== null && b.bedLabel !== null) return compareBedLabels(a.bedLabel, b.bedLabel);
    if (a.bedLabel !== null) return -1;
    if (b.bedLabel !== null) return 1;
    return a.admittedAt.getTime() - b.admittedAt.getTime();
  });
}
